var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcFileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C10.7452 0 0 10.7452 0 24V176C0 189.255 10.7452 200 24 200H176C189.255 200 200 189.255 200 176V24C200 10.7452 189.255 0 176 0H24ZM73.4253 120.511C77.3202 125.708 81.2243 130.916 84.3838 130.916C90.3214 130.916 96.886 121.148 103.596 111.165C112.734 97.5667 122.142 83.5686 130.6 93.3088C135.918 99.4364 141.399 112.847 146.227 124.66C147.909 128.774 149.511 132.695 151 136.047V140.8C151 146.441 146.441 151 140.8 151H59.2C56.4948 151 53.9004 149.925 51.9875 148.012C50.0746 146.1 49 143.505 49 140.8V137.444C50.9327 133.111 52.9016 128.234 54.6849 123.817C56.4404 119.469 58.016 115.566 59.2 113.066C62.5485 106 67.9778 113.244 73.4253 120.511ZM79.6 64.3C79.6 72.7558 72.7558 79.6 64.3 79.6C55.8442 79.6 49 72.7558 49 64.3C49 55.8442 55.8442 49 64.3 49C72.7558 49 79.6 55.8442 79.6 64.3Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcFileImage);
export default __webpack_public_path__ + "static/media/mc-file-image.cc9177de95614492e206b3762d01c246.svg";
export { ForwardRef as ReactComponent };